'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('tfMultiStepsIndicator', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      steps: '<',
      selected: '<'
    },
    transclude: true,
    template: "\n            <div class=\"tf-multi-steps-indicator\">\n                <tf-multi-steps-indicator-step\n                    ng-repeat=\"step in steps\"\n                    step=\"step\"\n                    selected=\"selected\"\n                ></tf-multi-steps-indicator-step>\n            </div>\n        "
  };
});
ngModule.directive('tfMultiStepsIndicatorStep', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      step: '<',
      selected: '<'
    },
    template: "\n            <div class=\"tf-multi-steps-indicator-step\"\n                 ng-class=\"{selected: step.id === selected}\">\n                <span>{{::step.label}}</span>\n            </div>\n        "
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/tf-form/tf-multi-steps-indicator.js
// module id = 3013
// module chunks = 13